export default "__VITE_ASSET__vo4f1XMm__"